import { IGetLatestScoreByDocumentResponse, IScoreReportPayload } from '../types/api';
import { isCompanyDocument } from './mapToCreditScoreData';

export function buildScoreReportPayload(score: IGetLatestScoreByDocumentResponse): IScoreReportPayload {
  return {
    scoreId: score.score.scoreId,
    document: score.score.document,
    reportType: isCompanyDocument(score.score.documentType) ? 'PJ' : 'PF',
  };
}
